export const HOME_PAGE_FLEXIPAY_URL = `https://www.cimb.com.sg/en/business/solutions-products/loans-financing/commercial-loans-financing/flexipay.html`;
export const HOME_PAGE_SME_URL = `https://www.cimb.com.sg/en/business/home.html`;
export const CONTACT_US_URL = `https://www.cimb.com.sg/en/personal/help-support/contact-us.html`;
export const GG_TERMS_URL = `https://policies.google.com/terms`;
export const GG_PRIVACY_URL = `https://policies.google.com/privacy`;
